var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 37 37",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-2 {\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        fill: none;\n      }\n\n      .cls-3 {\n        clip-path: url(#clippath-1);\n      }\n\n      .cls-4 {\n        clip-path: url(#clippath);\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    width: 37,
    height: 37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: -37.98,
    y: -746.5,
    width: 75,
    height: 1080
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M12.63,12.56h8.1v3.53c.12-.2.18-.31.24-.42.32-.56.69-1.07,1.23-1.47.31-.23.6-.49.94-.67.54-.28,1.07-.59,1.66-.74.32-.08.62-.19.95-.25.37-.07.74-.1,1.11-.17.54-.1,1.07-.03,1.61-.07.19-.02.37.06.55.08.18.02.41-.06.53.02.18.12.4-.04.53.15.47,0,.9.17,1.33.34.4.16.79.31,1.17.53.39.23.74.5,1.12.73.14.08.24.24.36.35.47.42.88.9,1.24,1.42.28.4.5.85.7,1.3.26.57.48,1.15.6,1.77.04.22.13.43.16.65.03.21.07.43.11.63.03.19.02.38.07.56.14.56.06,1.13.08,1.69.01.57,0,1.15,0,1.72v11.22h-8.06v-.42c0-3.89,0-7.78,0-11.67,0-.65-.06-1.32-.26-1.95-.16-.5-.27-1.04-.66-1.45-.41-.8-1.15-1.17-1.95-1.46-.55-.2-1.13-.22-1.69-.16-.53.06-1.06.16-1.52.48-.1.07-.21.11-.3.18-.22.17-.47.33-.66.54-.34.39-.64.81-.86,1.28-.2.42-.34,1.01-.34,1.37,0,4.41,0,8.82,0,13.22-.36.07-7.97.07-7.97.07l-.12-22.94Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1.08,
    y: 12.53,
    width: 7.11,
    height: 22.97
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M4.32,9.61c-.65,0-1.39-.18-2.09-.51-.28-.13-.5-.35-.75-.53-.28-.2-.44-.49-.66-.74-.28-.31-.38-.71-.5-1.09-.14-.47-.21-.95-.17-1.44.01-.16.08-.31.09-.47,0-.15.09-.3.13-.45.04-.15.04-.33.13-.45.18-.26.28-.57.53-.79.28-.26.52-.57.86-.77.44-.26.9-.45,1.4-.59.26-.07.52-.06.78-.14.24-.08.53-.05.79,0,.54.08,1.09.15,1.61.36.49.2.87.54,1.3.82.4.57.85,1.1.97,1.83.02.16.06.31.08.47.02.14.08.27.08.43,0,.53-.12,1.03-.28,1.52-.15.44-.4.83-.73,1.17-.41.42-.85.77-1.4.97-.38.14-.76.27-1.17.33-.28.04-.56.06-.98.08Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.60c55cfeea6dffa8e719507d683a5e7c.svg";
export { ForwardRef as ReactComponent };